export type LogMeta = Record<string, unknown>;

class NoopLogger {
  debug(_msg: string, _meta?: LogMeta) { return; }
  info(_msg: string, _meta?: LogMeta) { return; }
  warn(_msg: string, _meta?: LogMeta) { return; }
  error(_msg: string, _meta?: LogMeta) { return; }
  fatal(_msg: string, _meta?: LogMeta) { return; }
  async flush() { return; }
}

export const logger = new NoopLogger();

export default { logger };
